// Kiosk-/tablet-rollen: welke mobiele tabbladen een rol standaard mag zien.
// Voorbereide kiosk-rol "urenregistratie" ziet standaard alleen de Klok-tab
// (in-/uitklokken). De beheerder kan dit per rol overrulen in de Rechten-tab.
export const DEFAULT_MOBILE_TABS = { urenregistratie: ["klok"] };

// Bepaalt de toegestane mobiele tabbladen voor een rol.
// - expliciete config (permissions.mobileTabs[role]) wint; lege lijst = alle tabbladen
// - geen config: val terug op DEFAULT_MOBILE_TABS
// - retourneert null => geen beperking (alle tabbladen zichtbaar)
export function resolveMobileTabs(role, permMobileTabs) {
  const v = permMobileTabs && permMobileTabs[role];
  if (Array.isArray(v)) return v.length ? v : null;
  const d = DEFAULT_MOBILE_TABS[role];
  return Array.isArray(d) && d.length ? d : null;
}
